module.exports = __webpack_public_path__ + "img/electronic_electric_no_zone_selected.aec23cf4.svg";